import { Box, Flex, Grid, GridItem, Text } from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { GiOrganigram } from 'react-icons/gi'
import { LiaPersonBoothSolid } from 'react-icons/lia'
import { MdOutlineAccountTree, MdOutlineEvent, MdOutlineQuestionAnswer, MdOutlineHandshake } from 'react-icons/md'
import { AiOutlineUser, AiOutlineFileSearch } from 'react-icons/ai'
import { DashboardAPI } from '../../Apis/dashboardApi'
import { useToastWrapper } from '../../Wrapper/toastWrapper'
import { errorHandler } from '../../Utils/handler'
import { formatVersion, getCachedServerHash } from '../../Utils/version' // Claude: version display 28-03-2026

type Props = {}

const Dashboard = (props: Props) => {

  const [data, setData] = useState<any>({})

  const {error, success} = useToastWrapper()

  const getData = async() => {
    try{
      const res = await DashboardAPI.getDashboardData();
      if(res){
        setData(res.data.data)
      }
    }
    catch(err){
      error(errorHandler(err))
    }
  }

    useEffect(()=>{
      getData()
    },[])
  return (
    <Box p={4} bg={'#F5F5F5'} minH={'100%'}>
          <Text>Dashboard</Text>
          <Grid
            templateColumns="repeat(4, 1fr)"
            gap={4}
            mt={4}
            w="100%"
            h="100%"
          >
            {/* Claude: reordered — Sellers, Buyers first; Events, Organizers last 23-02-2026 */}
            <GridItem colSpan={1}>
              <Flex
                w="100%"
                h="100%"
                bg="white"
                borderRadius="md"
                alignItems={'center'}
                p={4}
                gap={6}
              >
                <Box p={2} borderRadius={'50%'} bg={'#FDEDE5'}>
                  <LiaPersonBoothSolid style={{width:"30px", height:'30px', color:'#F5793D'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>
                    {
                      data?.sellers || 0
                    }
                  </Text>
                  <Text
                    fontSize={'xs'}
                    color={'gray.500'}
                  >
                    Total Sellers
                  </Text>
                </Box>
              </Flex>
            </GridItem>
            <GridItem colSpan={1}>
              <Flex
                w="100%"
                h="100%"
                bg="white"
                borderRadius="md"
                alignItems={'center'}
                p={4}
                gap={6}
              >
                <Box p={2} borderRadius={'50%'} bg={'#FDEDE5'}>
                  <AiOutlineUser style={{width:"30px", height:'30px', color:'#F5793D'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>
                    {
                      data?.buyers || 0
                    }
                  </Text>
                  <Text
                    fontSize={'xs'}
                    color={'gray.500'}
                  >
                    Total Buyers
                  </Text>
                </Box>
              </Flex>
            </GridItem>
            {/* Claude: Industries card — count of top-level taxonomy nodes 23-02-2026 */}
            <GridItem colSpan={1}>
              <Flex
                w="100%"
                h="100%"
                bg="white"
                borderRadius="md"
                alignItems={'center'}
                p={4}
                gap={6}
              >
                <Box p={2} borderRadius={'50%'} bg={'#FDEDE5'}>
                  <MdOutlineAccountTree style={{width:"30px", height:'30px', color:'#F5793D'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>
                    {data?.industries || 0}
                  </Text>
                  <Text
                    fontSize={'xs'}
                    color={'gray.500'}
                  >
                    Total Industries
                  </Text>
                </Box>
              </Flex>
            </GridItem>
            <GridItem colSpan={1}>
              <Flex
                w="100%"
                h="100%"
                bg="white"
                borderRadius="md"
                alignItems={'center'}
                p={4}
                gap={6}
              >
                <Box p={2} borderRadius={'50%'} bg={'#FDEDE5'}>
                  <MdOutlineEvent style={{width:"30px", height:'30px', color:'#F5793D'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>
                    {
                      data?.events || 0
                    }
                  </Text>
                  <Text
                    fontSize={'xs'}
                    color={'gray.500'}
                  >
                    Total Events
                  </Text>
                </Box>
              </Flex>
            </GridItem>
            <GridItem colSpan={1}>
              <Flex
                w="100%"
                h="100%"
                bg="white"
                borderRadius="md"
                alignItems={'center'}
                p={4}
                gap={6}
              >
                <Box p={2} borderRadius={'50%'} bg={'#FDEDE5'}>
                  <GiOrganigram style={{width:"30px", height:'30px', color:'#F5793D'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>
                    {
                      data?.eventOrganizers || 0
                    }
                  </Text>
                  <Text
                    fontSize={'xs'}
                    color={'gray.500'}
                  >
                    Total Organizers
                  </Text>
                </Box>
              </Flex>
            </GridItem>
            {/* Claude: RFX, RFX Responses, Meetings counts 12-04-2026 */}
            <GridItem colSpan={1}>
              <Flex w="100%" h="100%" bg="white" borderRadius="md" alignItems={'center'} p={4} gap={6}>
                <Box p={2} borderRadius={'50%'} bg={'#FDEDE5'}>
                  <AiOutlineFileSearch style={{width:"30px", height:'30px', color:'#F5793D'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>{data?.rfxCount || 0}</Text>
                  <Text fontSize={'xs'} color={'gray.500'}>Total RFX</Text>
                </Box>
              </Flex>
            </GridItem>
            <GridItem colSpan={1}>
              <Flex w="100%" h="100%" bg="white" borderRadius="md" alignItems={'center'} p={4} gap={6}>
                <Box p={2} borderRadius={'50%'} bg={'#FDEDE5'}>
                  <MdOutlineQuestionAnswer style={{width:"30px", height:'30px', color:'#F5793D'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>{data?.rfxResponseCount || 0}</Text>
                  <Text fontSize={'xs'} color={'gray.500'}>Total RFX Responses</Text>
                </Box>
              </Flex>
            </GridItem>
            <GridItem colSpan={1}>
              <Flex w="100%" h="100%" bg="white" borderRadius="md" alignItems={'center'} p={4} gap={6}>
                <Box p={2} borderRadius={'50%'} bg={'#FDEDE5'}>
                  <MdOutlineHandshake style={{width:"30px", height:'30px', color:'#F5793D'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>{data?.meetingCount || 0}</Text>
                  <Text fontSize={'xs'} color={'gray.500'}>Total Meetings</Text>
                </Box>
              </Flex>
            </GridItem>
            {/* Claude: live session counts — sellers and buyers with active JWT 30-04-2026 */}
            <GridItem colSpan={1}>
              <Flex w="100%" h="100%" bg="white" borderRadius="md" alignItems={'center'} p={4} gap={6}>
                <Box p={2} borderRadius={'50%'} bg={'#E8F5E9'}>
                  <LiaPersonBoothSolid style={{width:"30px", height:'30px', color:'#2E7D32'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>{data?.liveSellerCount ?? 0}</Text>
                  <Text fontSize={'xs'} color={'gray.500'}>Live Sellers</Text>
                </Box>
              </Flex>
            </GridItem>
            <GridItem colSpan={1}>
              <Flex w="100%" h="100%" bg="white" borderRadius="md" alignItems={'center'} p={4} gap={6}>
                <Box p={2} borderRadius={'50%'} bg={'#E8F5E9'}>
                  <AiOutlineUser style={{width:"30px", height:'30px', color:'#2E7D32'}}/>
                </Box>
                <Box flexGrow={'1'}>
                  <Text>{data?.liveBuyerCount ?? 0}</Text>
                  <Text fontSize={'xs'} color={'gray.500'}>Live Buyers</Text>
                </Box>
              </Flex>
            </GridItem>
          </Grid>
          {/* Claude: version string in dashboard footer 28-03-2026 */}
          <Text fontSize={'10px'} color={'gray.400'} textAlign={'right'} mt={4}>
            {formatVersion(process.env.REACT_APP_GIT_HASH || '??', getCachedServerHash())}
          </Text>
    </Box>
  )
}

export default Dashboard